import React, { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Icon, { ICONS, COLORS } from '../../general-components/icon';
import { GreenroomState as GS } from '../../../stores/types/types';
import * as l from './effects/elements';
import { AVContext } from '../../../contexts/audio-video';
import useUserActions from '../../../hooks/use-user-actions';
import tellysmiling from '../../../images/telly-transitions/telly-smiling.svg';

interface OwnProps {
	onClear?: () => void,
	isDeviceTab?: boolean,
}

export default function Preview(props: OwnProps) {
	const { onClear = () => {} } = props;

	const videoRef = useRef<HTMLVideoElement>(null);
	const mainVideoStream = useSelector((s: GS) => s.VideoReducer.mainVideoStream);
	const { selectedVBG } = useSelector((s: GS) => s.ContentReducer);

	const { getAV } = useContext(AVContext);
	const { video } = getAV();

	const { toggleVideo } = useUserActions();

	useEffect(() => {
		if (video && videoRef.current) {
			videoRef.current.srcObject = mainVideoStream;
		}
	}, [video, mainVideoStream]);

	return (<>
		<div className='sticky-video-container-profile-tab'>
			<l.TitleContainer>
				<l.Title>
					<Icon name={ICONS.CAMERA_ON} size={16} color={COLORS.TEXT_GRAY_300} />
					<h6 className='bl-font-header'>Feed</h6>
				</l.Title>
				<l.ClearButton
					hidden={props.isDeviceTab}
					className={selectedVBG ? 'shown' : ''}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onClear();
					}}
				>
					<Icon name={ICONS.CLOSE} color={COLORS.TEXT_GRAY_400} size={16} className="margin-right-small" />
					<span className="bl-font-l1">Remove Effect</span>
				</l.ClearButton>
			</l.TitleContainer>
			{video
				? <video
					autoPlay
					playsInline
					muted
					style={{
						...l.FullWidthStyle,
						transform: 'scaleX(-1)',
					}}
					ref={videoRef}
					/>
				: <div style={l.FullWidthStyle}>
					<l.NoVideoTelly src={tellysmiling} alt='telly-smiling' />
					<div style={{ zIndex: 1 }}>
						<div className='bl-font-s1 text-gray-200 text-align-center'>
							Your camera is turned off
						</div>
						<l.BigGradientButton
							className='bl-font-l1 text-gray-1200 button-background-shading button-pillbox sherbert'
							onClick={() => toggleVideo()}
						>
							<Icon name={ICONS.CAMERA_ON} size={12} color={COLORS.TEXT_GRAY_300} />
							<span className='margin-left-small'>Enable for Preview</span>
						</l.BigGradientButton>
					</div>
				</div>
			}
			<div className='sticky-video-container-profile-tab-shadow'/>
		</div>
	</>);
}
